module.exports = __webpack_public_path__ + "static/media/puzzle.dc5c92d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/puzzle.svg
// module id = 363
// module chunks = 0